import React, { useEffect, useState } from "react";
import RobitoLogo from "../components/AppLogo";
import "../App.css";
import { apiPostAuth } from "../utils/api"; // Assuming resend-email endpoint requires auth

const VerifyEmailPage = () => {
  const [countdown, setCountdown] = useState(100);
  const [resending, setResending] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiPostAuth("account/check_email_verified.php");
        if(response.status === "error"){
          window.location.href = "/login";
        }else{
          if (response.is_verified === 1) {
            window.location.href = "/dashboard";
          }
        }
        
      } catch (error) {
        
      }
    };

    fetchData();
  }, []);

  // Countdown timer
  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const handleResendEmail = async () => {
    if (countdown > 0) return; // Prevent click before countdown finishes
    try {
      setResending(true);
      // Call your resend verification email endpoint (adjust if needed)
      const response = await apiPostAuth("account/resend_verification.php");
      if (response.result === 1) {
        if(response.is_verified === 1){
          window.location.href = "/dashboard";
        }else{
          alert("Verification email has been resent!");
          setCountdown(100);
        }

        
      }else{
        alert(response.message || "Failed to resend email. Please try again.");
      }

       // Restart countdown
    } catch (error) {
      alert("Failed to resend email. Please try again.");
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="auth-card">
        <RobitoLogo />
        <h2 className="form-title">Verifikasi Email Diperlukan</h2>
        <p className="text-center mb-4" style={{ textAlign: "center", marginBottom: "1rem" }}>
        Kami telah mengirim link verifikasi ke emailmu.
        Mohon cek email kamu (termasuk kotak spam).
        Muat ulang halaman ini jika kamu sudah verifikasi email.
        </p>

        <button
        type="button"
        className="primary-button resend-btn"
        style={{
            opacity: countdown > 0 ? 0.7 : 1,
            cursor: countdown > 0 ? "not-allowed" : "pointer",
        }}
        onClick={handleResendEmail}
        disabled={countdown > 0 || resending}
        >
        {countdown > 0
            ? `Resend Email (${countdown}s)`
            : resending
            ? "Resending..."
            : "Resend Email"}
        </button>


        <div className="copyright">© MySite.co.id 2025</div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
